/**
 * Erreurs du CRM ne visant aucune question précise.
 *
 * Cas couverts : règle interne du CRM, dossier déjà transmis, service
 * injoignable, ou refus visant un champ que le candidat ne renseigne pas
 * lui-même (filière, niveau).
 *
 * Affiché à la fois sur l'écran de confirmation ET sur l'écran du formulaire :
 * lorsqu'un envoi est refusé pour plusieurs motifs à la fois, le candidat est
 * ramené au champ corrigeable, et il doit malgré tout voir le message qui
 * l'invite à nous contacter — sans quoi il corrige, réessaie, et échoue de
 * nouveau sans comprendre.
 */

export default function SalesforceGlobalErrors({ errors }) {
  if (!errors || errors.length === 0) return null;

  return (
    <div
      className="salesforce-global-error"
      role="alert"
      aria-live="assertive"
      style={{
        background: '#fff4e5',
        border: '1px solid #e0c090',
        borderRadius: '4px',
        color: '#8a4b00',
        margin: '0 auto 16px',
        maxWidth: '640px',
        padding: '12px 16px'
      }}
    >
      {errors.map((error, index) => (
        <p key={index} style={{ margin: index ? '8px 0 0' : 0 }}>
          {error.message}
          {error.detail ? (
            <span style={{ display: 'block', fontSize: '0.85rem', fontStyle: 'italic', marginTop: '4px' }}>
              {error.detail}
            </span>
          ) : null}
        </p>
      ))}
    </div>
  );
}
